import { FormControl, FormHelperText, TextField } from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab';
import React from 'react';
import { createSelector } from 'reselect';
import lodash from 'lodash';
import { IRootState } from '../../../../@types/redux';
import { IPumpingStationMotorEfficiency } from '../../../../@types/model/masterData/pumpingStation/motorEfficiency';
import { connect } from 'react-redux';
import MasterDataPumpingStationMotorEfficiencyFunctions from '../../../../store/masterData/pumpingStation/motorEfficiency/functions';

interface IPumpingStationMotorEfficiencySelectorProps {
    value : string;
    disabled ?: boolean;
    className ?: string;
    required ?: boolean;
    onChange : (value : string) => void;

    isLoading : boolean;
    motorEfficiencies : Array<IPumpingStationMotorEfficiency>;
}

interface IPumpingStationMotorEfficiencySelectorState { }

class PumpingStationMotorEfficiencySelectorComponent extends React.Component<IPumpingStationMotorEfficiencySelectorProps, IPumpingStationMotorEfficiencySelectorState> {
    constructor(props : IPumpingStationMotorEfficiencySelectorProps) {
        super(props);

        this.state = {};
    }

    public componentDidMount() {
        MasterDataPumpingStationMotorEfficiencyFunctions.load();
    }

    private readonly onChange = (event : React.ChangeEvent<unknown>, value : {
        label : string;
        value : string;
    } | null | undefined) => {
        this.props.onChange(value?.value ?? '');
    };

    private readonly getData = (state : IPumpingStationMotorEfficiencySelectorState, props : IPumpingStationMotorEfficiencySelectorProps) => props.motorEfficiencies;
    private readonly getValue = (state : IPumpingStationMotorEfficiencySelectorState, props : IPumpingStationMotorEfficiencySelectorProps) => props.value;
    private readonly getRequired = (state : IPumpingStationMotorEfficiencySelectorState, props : IPumpingStationMotorEfficiencySelectorProps) => props.required;

    private readonly getMotorEfficiencies = createSelector([
        this.getData,
    ], (motorEfficiencies) => motorEfficiencies.filter(x => x.isActive).map(x => x.name).sort());

    private readonly getMotorEfficienciesForDropdown = createSelector([ 
        this.getRequired, this.getMotorEfficiencies,
    ], (required, motorEfficiencies) => {
        
        const dropdownData = lodash.map(motorEfficiencies, (element) => ({ label: element, value: element }));
        
        if (!required) {
            dropdownData.unshift({
                label: 'ALL',
                value: '',
            });
        }

        return dropdownData;
    });

    private readonly getSelectedValue = createSelector([ 
        this.getValue, this.getRequired, this.getMotorEfficiencies,
    ], (value, required, motorEfficiencies) => {
        if (value) {
            const motorEfficiency = motorEfficiencies.find(element => element === value);

            if (motorEfficiency) {
                return { label: motorEfficiency, value: motorEfficiency };
            } else {
                return { label: value, value };
            }
        }

        if (!value && !required) {
            return {
                label: 'ALL',
                value: '',
            };
        }

        return null;
    });

    public readonly render = () => {
        const { required, className, disabled } = this.props;

        const dropdownData = this.getMotorEfficienciesForDropdown(this.state, this.props);

        const value = this.getSelectedValue(this.state, this.props);

        return (
            <FormControl margin={'normal'} fullWidth className={className} disabled={disabled} error={required && !value}>
                <Autocomplete 
                    id={'motorEfficiency'}
                    options={dropdownData}
                    value={value}
                    getOptionSelected={(option, val) => option.value === val.value}
                    getOptionLabel={option => option.label}
                    onChange={this.onChange}
                    disableClearable={required}
                    openOnFocus
                    renderInput={params => <TextField error={required && !value} {...params} fullWidth label={'Motor Efficiency'} />}
                />
                {
                    required && !value &&
                    <FormHelperText error>Required</FormHelperText>
                }
            </FormControl>
        );
    };
}

const mapStateToProps = (state : IRootState) => {
    return { 
        isLoading: state.masterData.pumpingStation.motorEfficiency.isLoading,
        motorEfficiencies: state.masterData.pumpingStation.motorEfficiency.motorEfficiencies,
    };
};

const PumpingStationMotorEfficiencySelector = connect(
    mapStateToProps,
)(PumpingStationMotorEfficiencySelectorComponent);

export default PumpingStationMotorEfficiencySelector;